import { Button, Col, ErrorSummary, HorizontalRule, InPageAlert, Row } from '@snsw/react-component-library';
import React, { createRef, Fragment, useEffect, useRef, useState } from 'react';
import { DrawingDetails } from './components/DrawingDetails';
import styles from './DrawingsAndTechDetails.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { storeDrawings } from 'plantDesign/redux/plantDesignDrawingAndTechSlice';
import { PagePath } from 'shared/constants/pagePath';

export const AddDrawing = (props) => {
  const drawingRef = useRef([]);
  const combineErrors = useRef({});

  const dispatch = useDispatch();
  const application = useSelector((state) => state.application);

  const location = useLocation();
  const navigate = useNavigate();

  const [drawings, setDrawings] = useState(location.state?.drawings || []);

  const [showErrors, setShowErrors] = useState(false);
  const [errorSummary, setErrorSummary] = useState([]);
  const [updatingDrawingList, setUpdatingDrawingList] = useState(false);

  const applicationId = application.applicationId;

  const addAnotherDrawing = () => {
    //max drawing is 3

    if (drawings.length >= 3) return;

    let items = [...drawings];
    items.push({});

    setDrawings(items);
  };

  const removeDrawingDetails = (index) => {
    if (drawings.length <= 1) return;

    setUpdatingDrawingList(true);

    const items = drawings.filter((e, i) => i !== index);
    setDrawings(items);

    combineErrors.current = {}; //reset combine error
    drawingRef.current.splice(index, 1);

    //this is to trigger re-render of the drawing list
    setTimeout(() => {
      setUpdatingDrawingList(false);
    }, 0);
  };

  const onDrawingDetailsChange = (details, index) => {
    let items = drawings.map((e, i) => {
      if (i === index) {
        return { ...details };
      } else {
        return e;
      }
    });
    setDrawings(items);
  };

  const addDrawingRef = (el, index) => {
    const ref = createRef();
    ref.current = el;
    drawingRef.current[index] = ref;
  };

  const onErrorDrawingDetails = (errorDetails, index) => {
    combineErrors.current[index] = errorDetails;

    let errorArr = [];
    Object.keys(combineErrors.current).forEach((key) => {
      if (Array.isArray(combineErrors.current[key]) && combineErrors.current[key].length > 0)
        errorArr = errorArr.concat(combineErrors.current[key]);
    });

    setErrorSummary(errorArr);
  };

  const validateAll = () => {
    const result = [];
    drawingRef.current.forEach((ref) => {
      if (ref.current) {
        result.push(ref.current.validate());
      }
    });

    return result.reduce((p, c) => {
      return p && c;
    }, true);
  };

  const onSave = () => {
    if (validateAll()) {
      dispatch(storeDrawings(drawings));
      navigate(PagePath.plantDesignDrawingAndTechnicalDetails);
    } else {
      setShowErrors(true);
    }
  };

  useEffect(() => {
    //clear state
    window.history.replaceState({}, document.title);
  }, []);

  return (
    <>
      <Row>
        <Col span={8}>
          <ErrorSummary errors={errorSummary} />

          {!updatingDrawingList && (
            <>
              {drawings.map((x, index) => (
                <Fragment key={index}>
                  <DrawingDetails
                    index={index}
                    ref={(el) => addDrawingRef(el, index)}
                    showRemoveButton={drawings.length >= 2}
                    onRemoveClick={removeDrawingDetails}
                    details={x}
                    onChange={(details) => {
                      onDrawingDetailsChange(details, index);
                    }}
                    onErrorChange={(error) => {
                      onErrorDrawingDetails(error, index);
                    }}
                    triggerValidate={showErrors}
                    applicationId={applicationId}
                  />
                </Fragment>
              ))}
            </>
          )}
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          {drawings.length < 3 && (
            <Button className={styles.marginTop2rem} variant="secondary" onClick={addAnotherDrawing}>
              + Add another drawing
            </Button>
          )}

          {drawings.length >= 3 && (
            <InPageAlert
              variant="info"
              title="You can provide a maximum of three representational drawings."
              className={styles.marginTopOneHalf}
            />
          )}
        </Col>
      </Row>

      <HorizontalRule />

      <Button variant="primary" onClick={onSave}>
        Save
      </Button>

      <Button
        className={styles.mobileSaveExitMargin}
        variant="secondary"
        onClick={() => {
          navigate(PagePath.plantDesignDrawingAndTechnicalDetails);
        }}
      >
        Cancel
      </Button>
    </>
  );
};
